import { render, staticRenderFns } from "./AppArrow.vue?vue&type=template&id=665a9297&scoped=true&"
import script from "./AppArrow.vue?vue&type=script&lang=js&"
export * from "./AppArrow.vue?vue&type=script&lang=js&"
import style0 from "./AppArrow.vue?vue&type=style&index=0&id=665a9297&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665a9297",
  null
  
)

export default component.exports